import { AdvancedMarker } from '@vis.gl/react-google-maps'
import { memo } from 'react'

import MarkerAlarm from '../../images/markerAlarm.svg'
import MarkerList from '../../images/markerList.svg'
import MarkerOffline from '../../images/markerOffline.svg'
import MarkerOnline from '../../images/markerOnline.svg'

const DeviceMarker = memo(({ deviceId, device, onClick, title, 'aria-label': ariaLabel }) => {
  const markerIcon = getMarkerIcon(device)

  const handleClick = () => {
    onClick(device)
  }

  return (
    <AdvancedMarker
      position={{
        lat: device.position.latitude,
        lng: device.position.longitude
      }}
      onClick={handleClick}
      title={title}
      aria-label={ariaLabel}
    >
      <img
        src={markerIcon}
        alt={`dispositivo ${device.name}`}
        style={{
          width: '80px',
          height: '80px',
          cursor: 'pointer',
          animation: deviceId === device.id || (device.devicesIds && device.devicesIds.includes(deviceId)) ? 'bounce 2s ease infinite' : 'none'
        }}
      />
      {device.id === deviceId || (device.devicesIds && device.devicesIds.includes(deviceId)) && (
        <style>
          {`
            @keyframes bounce {
              70% { transform: translateY(0%); }
              80% { transform: translateY(-15%); }
              90% { transform: translateY(0%); }
              95% { transform: translateY(-7%); }
              97% { transform: translateY(0%); }
              99% { transform: translateY(-3%); }
              100% { transform: translateY(0); }
            }
          `}
        </style>
      )}
    </AdvancedMarker>
  )
}, ({ device: { position: prevPosition } }, { device: { position: nextPosition } }) => prevPosition.latitude === nextPosition.latitude && prevPosition.longitude === nextPosition.longitude)

const getMarkerIcon = (device) => {
  const { isAlive, isAlarm, isList } = device

  if (isList) return MarkerList
  if (isAlive) return MarkerOnline
  if (isAlarm) return MarkerAlarm
  return MarkerOffline
}

export default DeviceMarker